module.exports = __webpack_public_path__ + "static/header-537393c37adddaca498f3bc81bbba457.jpg";